import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Galleria, GalleriaModule } from 'primeng/galleria';
import { UtilService } from '@helpers/util.service';
import { fromEvent, Observable } from 'rxjs';
import { SettingsService } from '@app/settings.service';
import { VideoReviewComponent } from '@app/home/video-review/video-review.component';

type GalleriaClass = 'b12';

@Component({
  selector: 'app-galleria',
  standalone: true,
  imports: [CommonModule, GalleriaModule, VideoReviewComponent],
  templateUrl: './galleria.component.html',
  styleUrls: ['./galleria.component.scss'],
})
export class GalleriaComponent implements OnInit {

  @Input() images: string[];
  @Input() gClass: GalleriaClass;
  @Input() fullScreenButton: boolean;
  @Input() isStatic = false;
  @ViewChild('galleria') galleria!: any;

  items: string[];

  fullscreen: boolean;
  activeIndex: number = 0;
  isMobile$: Observable<boolean>;

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  constructor(
    private util: UtilService,
    private _settingsService: SettingsService,
  ) {}

  ngOnInit() {
    this.items = this.images.slice();
    this.isMobile$ = this._settingsService.isMobile();

    fromEvent(document, 'fullscreenchange').pipe(
    ).subscribe((ev) => {
      if (this.fullscreen) {
        this.closePreviewFullScreen();
      }
      this.fullscreen = !this.fullscreen;
    });

  }

  nextImage() {
    if (this.activeIndex < this.images.length - 1) {
      this.activeIndex++;
    }
  }

  prevImage() {
    if (this.activeIndex) {
      this.activeIndex--;
    }
  }

  isVideo(id: string): boolean {
    return id.includes('m3u8');
  }

  getVideoInfo(id: string) {
    return { id: this.items.indexOf(id), src: id, title: '' };
  }

  openPreviewFullScreen() {
    const elem = this.galleria?.element.nativeElement.querySelector('.p-galleria');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem['mozRequestFullScreen']) {
      /* Firefox */
      elem['mozRequestFullScreen']();
    } else if (elem['webkitRequestFullscreen']) {
      /* Chrome, Safari & Opera */
      elem['webkitRequestFullscreen']();
    } else if (elem['msRequestFullscreen']) {
      /* IE/Edge */
      elem['msRequestFullscreen']();
    }
  }

  closePreviewFullScreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (document['mozCancelFullScreen']) {
      document['mozCancelFullScreen']();
    } else if (document['webkitExitFullscreen']) {
      document['webkitExitFullscreen']();
    } else if (document['msExitFullscreen']) {
      document['msExitFullscreen']();
    }
  }

  url(uuId: string) {
    return this.isStatic ? uuId : `${this.util.getFilePath()}${uuId}/preview`;
  }
}
